module.exports = __webpack_public_path__ + "img/5.ef1338e3.jpg";